function initAnimations() {
  document.querySelectorAll('.image-with-text__grid').forEach(grid => {
    const isReverse = grid.classList.contains('image-with-text__grid--reverse');
    const media = grid.querySelector('.image-with-text__media-item');
    const text = grid.querySelector('.image-with-text__text-item');

    if (isReverse) {
      media?.classList.add('slide-in-right');
      text?.classList.add('slide-in-left');
    } else {
      media?.classList.add('slide-in-left');
      text?.classList.add('slide-in-right');
    }
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.image-with-text__media-item, .image-with-text__text-item')
    .forEach(el => observer.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnimations);
} else {
  initAnimations();
}
